
    import { Component, Vue, Prop, Watch } from "vue-property-decorator";
    import { PendingShift, Event } from "@/models";
    import ErrorNotification from "./ErrorNotification.vue";
    import { namespace } from "vuex-class";
    import moment from "moment";
    const schedule = namespace("schedule");
    const profile = namespace("profile");
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import { useAppInsights } from '../../store/modules/AppInsights'
    import TrainingVideos from '../shared/TrainingVideos.vue';

    @Component({
        components: {
            ErrorNotification,
            Loading,
            TrainingVideos
        },
    })
    export default class OpenNeed extends Vue {
        @profile.State public profileData!: any;
        @profile.State
        isAdmin!: boolean;
        @schedule.State public openNeedShiftMembers!: any;
        @schedule.State public assignmentDetail!: any;
        @schedule.State public openNeedsFacilities: any;
        @schedule.State public openNeedsDepartments: any;
        @schedule.State public openNeedsShiftDetails: any;
        @profile.State appInsightEventData!: any;
        @profile.State
        isImpersonating!: boolean;
        @Prop() currentEvent!: Event;
        @Prop() scheduleStartDate!: Date;
        @Prop() scheduleEndDate!: Date;
        buttonCaption: string = "Add to Schedule";
        buttonName: string = "btnAddToSchedule";
        isLoaded: boolean = true;
        needid!: number;
        departmentShiftId!: string;
        deptShiftDesc: string = '';
        deptShifts!: any;
        departmentPartialShiftId!: string;
        deptPartialShiftDesc: string = '';
        deptPartialShifts!: any;
        skillName: string = "";
        errorMsg: string = '';
        errorType: string = 'error';
        showErrorMsg: boolean = false;
        classFlag: string = '';
        data = {
            allShifts: [],
            shifts: [],
            selectedShift: "",
            shiftMembers: [],
            partialShifts: [],
            selectedPartialShift: null
        };
        shiftStartTime!: Date;
        shiftEndTime!: Date;
        partialShiftStartTime!: Date;
        partialShiftEndTime!: Date;
        actualPartialShiftStartTime: string = "6:30am";
        actualPartialShiftEndTime: string = "6:30pm";
        actualShiftStartTime: string = "6:30am";
        actualShiftEndTime: string = "6:30pm";
        showPartial: boolean = false;
        facilities: any = [];
        facilityDepts: any = [];
        selectedFacilityId: number = 0;
        selectedDeptId: number = 0;
        facilityName: string = '';
        departmentName: string = '';
        skills: any = [];
        selectedSkillId: number = 0;
        primarySkillId: number = 0;
        isLoading: boolean = false;
        loaderColor: string = "#0085ca";
        hasPartials: boolean = false;
        hasNeedsInPrimaryDept: boolean = true;

        async mounted() {
            this.buttonCaption =
                (this.currentEvent.type == "Assignment" && this.currentEvent.status == "Pending") ? "Withdraw" : "Add to Schedule";
            this.buttonName =
                (this.currentEvent.type == "Assignment" && this.currentEvent.status == "Pending") ? "btnWithdraw" : "btnAddToSchedule";
            this.skillName =  this.profileData.skills.find((x) => x.primary == true ).description;
            this.deptShifts = this.profileData.departmentShifts.filter((x) => x.canRequest == false);
            if (this.currentEvent.type == "Assignment" && this.currentEvent.status == "Pending") {
                this.loadopenNeeds();
            } else {
                this.loadopenNeedShiftMembers();
            }
        }

        loadopenNeedShiftMembers() {
            let dates = this.currentEvent.description.split(',');
            const payload = {
                selectedDate: this.currentEvent.date,
                username: this.profileData.username,
                start: moment(dates[0]).format("YYYY-MM-DD"),
                end: moment(dates[1]).format("YYYY-MM-DD"),
                includePartials: true,
            };

            this.$store
                .dispatch("schedule/getOpenNeeds", payload)
                .then((res) => {
                    this.facilities = this.openNeedsFacilities;
                    this.hasNeedsInPrimaryDept = this.openNeedsDepartments.filter(x => x.departmentId == this.profileData.deptId).length > 0;
                    this.selectedFacilityId = this.openNeedsFacilities.find(x => x.facilityId == this.profileData.facilityId) == undefined
                        ? this.openNeedsFacilities[0].facilityId : this.profileData.facilityId;
                    this.facilityName = this.openNeedsFacilities.find(x => x.facilityId == this.selectedFacilityId) == undefined
                        ? this.openNeedsFacilities[0].facilityName : this.profileData.facilityName;
                    this.facilityDepts = this.openNeedsDepartments.filter(x => x.facilityId == this.selectedFacilityId);

                    if (this.selectedFacilityId == this.profileData.facilityId) {
                        this.selectedDeptId = this.profileData.deptId;
                    }
                    else {
                        this.selectedDeptId = this.openNeedsDepartments.filter(x => x.facilityId == this.selectedFacilityId)[0].departmentId;
                    }
                    this.primarySkillId = this.profileData.skills.find(x => x.primary == true).id;

                    //remove duplicate from array having same shift code
                    const removeDuplicatesFromArrayByProperty = (arr, prop) => arr.reduce((accumulator, currentValue) => {
                        if (!accumulator.find(obj => obj[prop] === currentValue[prop])) {
                            accumulator.push(currentValue);
                        }
                        return accumulator;
                    }, [])

                    this.skills = removeDuplicatesFromArrayByProperty(res.data.map(x => { return { id: x.skillId, description: x.skill } }), 'id');
                    this.selectedSkillId = this.skills.length? this.skills[0].id : this.primarySkillId;
                    this.deptShifts = this.openNeedsShiftDetails.filter(x => x.departmentId == this.selectedDeptId && !x.isPartial);
                    const updatedShift: any = res.data.map((members) => {
                        if(members.isPartial){
                            members.description = members.shiftCode
                                + " " + this.formatTime(members.startTime)
                                + " - " + this.formatTime(members.endTime);
                        }
                        else{
                            members.description = members.shiftCode
                                + " " + this.formatTime(members.startTime)
                                + " - " + this.formatTime(members.endTime);
                        }

                        members.key = members.id + '-' + members.departmentShiftId;
                        return members;
                    });

                    this.data.allShifts = removeDuplicatesFromArrayByProperty(updatedShift, 'departmentShiftId');
                    this.data.partialShifts = updatedShift.filter(x => x.isPartial);
                    this.deptShifts = this.openNeedsShiftDetails.filter(x => x.departmentId == this.selectedDeptId && !x.isPartial);
                    this.deptPartialShifts = this.openNeedsShiftDetails.filter(x => x.departmentId == this.selectedDeptId && x.isPartial);
                    if(this.deptShifts.length){
                        this.setShiftDetails(this.deptShifts[0].departmentShiftId, this.deptShifts[0].departmentId);
                    }
                    else{
                        this.setShiftDetails(null, null);
                    }
                    

                    if (this.deptPartialShifts.length){
                        this.setPartialShiftDetails(this.deptPartialShifts[0].departmentShiftId, this.deptPartialShifts[0].departmentId);
                    }
                })
                .catch((err: any) => {
                    if (err) {
                        console.log(err);
                    }
                });
        }

        loadopenNeeds() {
            this.$store
                .dispatch("schedule/GetScheduleAssignmentDetail", this.currentEvent.id)
                .then(() => {
                    this.isLoaded = true;
                    if (this.assignmentDetail != undefined) {
                        this.facilityName = this.assignmentDetail.facilityName;
                        this.departmentName = this.assignmentDetail.departmentCode;
                        if(this.assignmentDetail.premiumLaborLevel){
                                this.assignmentDetail.description = this.assignmentDetail.shiftCode
                                    + " " + this.formatTime(this.assignmentDetail.startTime)
                                    + " - " + this.formatTime(this.assignmentDetail.endTime)
                                    + " (Incentive)";
                            }
                        else{
                            this.assignmentDetail.description = this.assignmentDetail.shiftCode
                            + " " + this.formatTime(this.assignmentDetail.startTime)
                            + " - " + this.formatTime(this.assignmentDetail.endTime);
                        }

                        this.deptShiftDesc = this.assignmentDetail.description;
                        this.actualShiftStartTime = this.formatTime(this.assignmentDetail.actualStartTime);
                        this.actualShiftEndTime = this.formatTime(this.assignmentDetail.actualEndTime);
                        this.needid = this.assignmentDetail.needId;
                        this.data.shiftMembers = this.assignmentDetail.shiftMembers.map((members) => {
                            members.name = members.firstName + " " + members.lastName;
                            return members;
                        });
                        this.skillName = this.assignmentDetail.skill;
                    }
                })
                .catch((err: any) => {
                    if (err) {
                        console.log(err); // Handle errors any way you want
                    }
                });
        }

        onOpenNeedFacilityChange(event) {
            this.selectedFacilityId = event.target.value;
            this.facilityDepts = this.openNeedsDepartments.filter(x => x.facilityId == event.target.value);
            this.facilityName = this.facilities.find(f => f.facilityId == event.target.value).facilityName;
            if (this.selectedFacilityId == this.profileData.facilityId) {
                this.selectedDeptId = this.profileData.deptId;
            }
            else {
                this.selectedDeptId = this.facilityDepts[0].departmentId;
            }
            this.departmentName = (this.facilityDepts.find(x => x.departmentId == this.selectedDeptId) || {}).departmentCode;
            this.deptShifts = this.openNeedsShiftDetails.filter(x => x.departmentId == this.selectedDeptId);
            if (this.deptShifts.length){
                this.setShiftDetails(this.deptShifts[0].departmentShiftId, this.deptShifts[0].departmentId);
            }
            else {
                this.setShiftDetails(null, null);
            }

            if (this.deptPartialShifts.length){
                this.setPartialShiftDetails(this.deptPartialShifts[0].departmentShiftId, this.deptPartialShifts[0].departmentId);
            }
        }

        onOpenNeedDepartmentChange(event) {
            this.selectedDeptId = parseInt(event.target.value);
            this.departmentName = (this.openNeedsShiftDetails.find(x => x.departmentId == event.target.value) || {}).departmentCode;
            this.deptShifts = this.openNeedsShiftDetails.filter(x => x.departmentId == event.target.value);
            if (this.deptShifts.length){
                this.setShiftDetails(this.deptShifts[0].departmentShiftId, this.deptShifts[0].departmentId);
            }
            else {
                this.setShiftDetails(null, null);
            }

            this.deptPartialShifts = this.openNeedsShiftDetails.filter(x => x.departmentId == this.selectedDeptId && x.isPartial);

            if (this.deptPartialShifts.length){
                this.setPartialShiftDetails(this.deptPartialShifts[0].departmentShiftId, this.deptPartialShifts[0].departmentId);
            }
        }

        onOpenNeedSkillChange(event) {
            this.selectedSkillId = event.target.value;
            this.skillName = this.skills.find(x => x.id == event.target.value).description;
            this.deptShifts = this.openNeedsShiftDetails.filter(x => x.departmentId == this.selectedDeptId && x.skillId == event.target.value);
            if (this.deptShifts.length){
                this.setShiftDetails(this.deptShifts[0].departmentShiftId, this.deptShifts[0].departmentId);
            }
            else {
                this.setShiftDetails(null, null);
            }

            if (this.deptPartialShifts.length){
                this.setPartialShiftDetails(this.deptPartialShifts[0].departmentShiftId, this.deptPartialShifts[0].departmentId);
            }
        }

        setShiftDetails(deptShiftId, deptId) {
            var selectedDeptShift = this.deptShifts.find(x => x.departmentShiftId == deptShiftId
                && x.departmentId == deptId && !x.isPartial);
            var selectedShiftDetails: any

            if (this.data.allShifts.length > 0) {
                this.data.shifts = this.data.allShifts.filter((shift: any) => { return shift.departmentId === this.selectedDeptId && !shift.isPartial && shift.skillId == this.selectedSkillId });
            }
            if (this.data.shifts.length > 0) {
                this.data.shifts.sort();

                selectedShiftDetails = this.data.shifts[0];
                selectedDeptShift = this.deptShifts.find(x => x.departmentShiftId == selectedShiftDetails.departmentShiftId
                    && x.departmentId == selectedShiftDetails.departmentId && !x.isPartial);
                
                this.data.selectedShift = selectedDeptShift? selectedDeptShift.id : "";
            } else {
                this.data.shifts = this.openNeedsShiftDetails.filter((shift: any) => { return shift.departmentId === this.selectedDeptId && !shift.isPartial && shift.skillId == this.selectedSkillId });
                if (this.data.shifts.length > 0) {
                    this.data.shifts.sort();

                    selectedShiftDetails = this.data.shifts[0];
                    selectedDeptShift = this.deptShifts.find(x => x.departmentShiftId == selectedShiftDetails.departmentShiftId
                        && x.departmentId == selectedShiftDetails.departmentId && !x.isPartial);
                    
                    this.data.selectedShift = selectedDeptShift? selectedDeptShift.id : "";
                }
                else{
                    this.data.selectedShift = "";
                }
            }

            if (selectedDeptShift){
                this.deptShiftDesc = selectedDeptShift.shiftDescription;
                this.shiftStartTime = selectedDeptShift.startTime;
                this.shiftEndTime = selectedDeptShift.endTime;
            }
            this.onOpenNeedShiftChanges();
        }

        setPartialShiftDetails(deptShiftId, deptId) {
            const selectedDeptShift = this.deptPartialShifts.find(x => x.departmentShiftId == deptShiftId
                && x.departmentId == deptId);

            if (this.data.allShifts.length > 0) {
                this.data.partialShifts = this.data.allShifts.filter((shift: any) => { return shift.id == this.data.selectedShift && shift.departmentId === this.selectedDeptId && shift.isPartial });
            }
            if (this.data.partialShifts.length > 0) {
                this.data.partialShifts.sort();
                this.data.selectedPartialShift = selectedDeptShift? selectedDeptShift.id : null;
            } else {
                this.data.selectedPartialShift = null;
            }

            if (selectedDeptShift){
                this.deptPartialShiftDesc = selectedDeptShift.shiftDescription;
                this.partialShiftStartTime = selectedDeptShift.startTime;
                this.partialShiftEndTime = selectedDeptShift.endTime;
            }

            this.onOpenNeedPartialShiftChanges();
        }

        onOpenNeedShiftChanges() {
            const filteredShift: any = this.data.shifts.filter((shift: any) => {
                return shift.id === this.data.selectedShift;
            });
            if (filteredShift.length){
                this.needid = filteredShift[0].id;
                this.actualShiftStartTime = this.formatTime(filteredShift[0].startTime);
                this.actualShiftEndTime = this.formatTime(filteredShift[0].endTime);
                this.departmentShiftId = filteredShift[0].departmentShiftId;

                this.data.shiftMembers = filteredShift[0].shiftMembers.map((members) => {
                    members.name = members.firstName + " " + members.lastName;
                    return members;
                });
            }           
            
            if (this.showErrorMsg) {
                this.showErrorMsg = false;
                this.errorMsg = "";
            }

            if (this.deptPartialShifts.length){
                this.setPartialShiftDetails(this.deptPartialShifts[0].departmentShiftId, this.deptPartialShifts[0].departmentId);
            }
        }

        onOpenNeedPartialShiftChanges() {
            const filteredShift: any = this.data.partialShifts.filter((shift: any) => {
                return shift.id === this.data.selectedShift && shift.departmentShiftId === this.data.selectedPartialShift;
            });
            
            if (filteredShift.length){
                this.needid = filteredShift[0].id;
                this.actualPartialShiftStartTime = this.formatTime(filteredShift[0].startTime);
                this.actualPartialShiftEndTime = this.formatTime(filteredShift[0].endTime);
                this.departmentPartialShiftId = filteredShift[0].departmentShiftId;

                this.data.shiftMembers = filteredShift[0].shiftMembers.map((members) => {
                    members.name = members.firstName + " " + members.lastName;
                    return members;
                });
            }

            
            if (this.showErrorMsg) {
                this.showErrorMsg = false;
                this.errorMsg = "";
            }
        }

        selectedShiftId(){
            let validShift: boolean = false;
            validShift = isNaN(parseInt(this.departmentShiftId)) ? false : true;
            return this.data.partialShifts.length && this.showPartial ? this.departmentPartialShiftId : validShift;
        }

        selectedShiftActualStartTime(){
            return this.data.partialShifts.length && this.showPartial && this.data.selectedPartialShift? this.actualPartialShiftStartTime : this.actualShiftStartTime;
        }

        selectedShiftActualEndTime(){
            return this.data.partialShifts.length && this.showPartial && this.data.selectedPartialShift? this.actualPartialShiftEndTime : this.actualShiftEndTime;
        }

        FireAction() {
            try {
                if (this.currentEvent.type == "Assignment" && this.currentEvent.status == "Pending") {
                    this.isLoading = true;
                    this.$store.dispatch('schedule/WithdrawEvent', { needid: this.needid, assignementid: this.currentEvent.id })
                        .then((res: any) => {
                            // showing message in MyScheduleView Screen and close modal only on success
                            this.isLoading = false;
                            this.$emit('showSuccessMsgPopUp');
                            this.$emit('closeSharedModal');
                        })
                        .catch((err: any) => {
                            if (err) {
                                this.isLoading = false;
                                console.log(err);
                                let parseResponse = err.request.responseText != "" ? JSON.parse(err.request.responseText) : err.request.responseText;
                                this.showErrorMsg = true;
                                this.errorMsg = (parseResponse.result != null || parseResponse.result != undefined) ? JSON.parse(parseResponse.result).Message : "An error has occurred. Please try again. If the error persists, contact Facility Scheduler support.";
                            }

                        });

                } else {
                    const requestBody = {
                        "needId": this.needid,
                        "tenantId": this.profileData.tenantId,
                        "deptShiftId": this.data.partialShifts.length && this.showPartial ? this.departmentPartialShiftId : this.departmentShiftId,
                        "date": this.currentEvent.date,
                        "deptId": this.selectedDeptId,
                        "staffId": this.profileData.staffId,
                        "scheduleStartDate": this.scheduleStartDate,
                        "scheduleEndDate": this.scheduleEndDate
                    };
                    this.isLoading = true;
                    this.$store
                        .dispatch("schedule/ScheduleOpenNeedRequest", requestBody)
                        .then((res) => {

                            //showing message in MyScheduleView Screen and close modal only on success
                            this.isLoading = false;
                            this.$emit('showSuccessMsgPopUp');
                            this.$emit('closeSharedModal');
                        })
                        .catch((err: any) => {
                            if (err) {
                                this.isLoading = false;
                                console.log(err, "error");
                                let parseResponse = err.request.responseText != "" ? JSON.parse(err.request.responseText) : err.request.responseText;
                                this.showErrorMsg = true;
                                this.errorMsg = (parseResponse.result != null || parseResponse.result != undefined) ? JSON.parse(parseResponse.result).Message : "An error has occurred. Please try again. If the error persists, contact Facility Scheduler support.";
                            }
                        });
                }
            } catch (error) {
                console.log(error);
            }
        }

        formatDate(date: Date): string {
            return moment(date).format("dddd, MMMM DD yyyy");
        }

        formatTime(t: Date): string {
            return moment(t).format("h:mm a");
        }

    }
